(ns minorodata.components.forms.password-strength-indicator
  (:require ["react-password-strength-bar" :default PasswordStrengthBar]
            ["password-sheriff" :refer (PasswordPolicy charsets)]))


(defn indicator [{:keys [field class
                         score-word-class-name score-word-style
                         user-inputs bar-colors score-words
                         min-length short-score-word
                         on-change-score]
                  :or   {user-inputs []
                         bar-colors ["#ddd" "#ef4836" "#f6b44d" "#2b90ef" "#25c281"]
                         score-words ["weak" "weak" "okay" "good" "strong"]
                         min-length 4
                         short-score-word "too short"
                         on-change-score (fn [])}}]
  (let [value (or (:value field) "")]
    [:<>
     [:> PasswordStrengthBar
      {:password           value
       :class              class
       :scoreWordClassName score-word-class-name
       :scoreWordStyle     score-word-style
       :userInputs         user-inputs
       :barColors          bar-colors
       :scoreWords         score-words
       :minLength          min-length
       :shortScoreWord     short-score-word
       :onChangeScore      on-change-score}]]))

(defn valid-password? [password]
  (let [pw-policy (new PasswordPolicy
                       (clj->js {:length   {:minLength 12}
                                 :contains {:expressions
                                            [(.-upperCase charsets)
                                             (.-lowerCase charsets)
                                             (.-specialCharacters charsets)
                                             (.-numbers charsets)]}}))]
    (.check pw-policy password)))

(defn hacky-indicator
  "This component hacks `react-password-strength-bar` to display a password
  strength bar that is either `weak` or `strong`.
  Real validation is done by Auth0's `password-sheriff` library."
  [{:keys [field class
           score-word-class-name score-word-style
           user-inputs bar-colors score-words
           min-length short-score-word
           on-change-score]
    :or   {user-inputs      []
           bar-colors       ["#ddd" "#ef4836" "#f6b44d" "#2b90ef" "#25c281"]
           score-words      ["weak" "weak" "weak" "weak" "strong"]
           min-length       4
           short-score-word "weak"
           on-change-score  (fn [])}}]
  (let [value (or (:value field) "")
        valid? (valid-password? value)
        str-zxcvb-recognizes-as-strong-password "RAAAxA!AAAr*A&AAAAa1!"
        str-zxcvb-recognizes-as-weak-password "aa"]
    [:<>
     [:> PasswordStrengthBar
      {:class              class
       :scoreWordClassName score-word-class-name
       :scoreWordStyle     score-word-style
       :userInputs         user-inputs
       :barColors          bar-colors
       :scoreWords         score-words
       :minLength          min-length
       :shortScoreWord     short-score-word
       :onChangeScore      on-change-score
       :password           (if valid?
                             str-zxcvb-recognizes-as-strong-password
                             str-zxcvb-recognizes-as-weak-password)}]]))


